(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  class Translate {
    /**
     * Initializes a new instance of the class.
     *
     * @constructor
     * @property {any} state - The current state of the carousel.
     * @property {any} previousTarget - The previous target element interacted with.
     */
    constructor() {
      this.state = null;
      this.element = null;
      this.previousTarget = null;
    }

    /**
     * Initializes the object with the provided state.
     * @param {Object} state - The state object to initialize with.
     */
    initialize(state, element) {
      this.state = state;
      this.element = element;
    }

    /**
     * Translates a value along the appropriate axis based on the current state.
     *
     * @param {number} value - The value to translate.
     * @returns {string} The translated value using either the x or y axis translation.
     */
    translate(value) {
      const axis = this.state.get('axis');
      return axis.getScroll() === 'x' ? Translate.x(value) : Translate.y(value);
    }

    /**
     * Translates the carousel element to the specified target position along the defined axis.
     *
     * @param {number} target - The target position to translate the carousel to.
     */
    to(target) {
      const axis = this.state.get('axis');
      const newTarget = Translate.roundToTwoDecimals(axis.direction(target));
      if (newTarget === this.previousTarget) {
        return;
      }

      this.element.style.transform = this.translate(newTarget);
      this.previousTarget = newTarget;
    }

    /**
     * Clears the transform style from the element.
     * If the element has no other inline styles after clearing the transform,
     * removes the 'style' attribute entirely.
     *
     * @returns {void}
     */
    clear() {
      this.element.style.transform = '';
      if (!this.element.getAttribute('style')) {
        this.element.removeAttribute('style');
      }
    }

    /**
     * Returns a CSS translate3d transformation string for the given x-axis value.
     *
     * @param {number} value - The number of pixels to translate along the x-axis.
     * @returns {string} The CSS transform string in the format 'translate3d(npx,0px,0px)'.
     */
    static x(value) {
      return 'translate3d(' + value + 'px,0px,0px)';
    }

    /**
     * Returns a CSS translate3d transformation string that moves an element along the Y-axis
     * by the specified number of pixels.
     *
     * @param {number} value - The number of pixels to translate along the Y-axis.
     * @returns {string} The CSS translate3d transformation string.
     */
    static y(value) {
      return 'translate3d(0px,' + value + 'px,0px)';
    }

    /**
     * Rounds a number to two decimal places.
     *
     * @param {number} num - The number to round.
     * @returns {number} The number rounded to two decimal places.
     */
    static roundToTwoDecimals(num) {
      return Math.round(num * 100) / 100;
    }
  }

  global.NewHomeSource.Carousel.Translate = Translate;
}(window));
